/* eslint-disable @typescript-eslint/no-explicit-any */
import {useEffect, useState} from 'react';
import {Platform} from 'react-native';
import {
  defaultAutoSinistreError,
  showErrorValuesDefault,
  showErrorValuesSubmit,
} from '../../data/constants/Sinistres/autoMoto';
import {IError} from '../../data/types/interface/Sinistres/autoMoto';

export const useForm = (
  data: any,
  Validate: any,
  handleCancel: any,
  handleSave: any,
  listAgence?: any,
  listContratSvg?: any,
) => {
  const [values, setValues] = useState(data);
  const [dto, setDto] = useState({error: true, data});
  const [showErrors, setShowErrors] = useState(showErrorValuesDefault);
  const [errors, setErrors] = useState<IError>(defaultAutoSinistreError);
  const handleChange = (
    name: string,
    value: any,
    fired: boolean,
    remove?: boolean,
  ) => {
    let _value = value;
    if (name === 'photo') {
      if (_value === 'INVALID INPUT') {
        setValues({...values, [name]: []});
      } else {
        if (Platform.OS !== 'web') {
          _value = {
            uri: value.uri,
            type: value.type,
            name: value.fileName,
          };
        }
        if (remove) {
          setValues({...values, [name]: _value});
        } else {
          const photos = [...values[name]];
          photos.push(_value);
          setValues({...values, [name]: photos});
        }
      }
    } else if (name === 'pieceJointeAgence') {
      const pieceJointe = value;
      if (pieceJointe === 'INVALID INPUT') {
        setValues({...values, [name]: []});
      } else {
        if (remove) {
          setValues({...values, [name]: pieceJointe});
        } else {
          const photos = [...values[name]];
          photos.push(pieceJointe);
          setValues({...values, [name]: photos});
        }
      }
    } else {
      let agence = '';
      if (name === 'numeroContrat') {
        const _value =
          listContratSvg &&
          listContratSvg.filter((elt: any) => elt.numeroPolice === value);

        agence = _value && _value[0] ? _value[0].agence : '';
      }
      setValues({
        ...values,
        [name]: _value,
        agence: agence !== '' ? agence : values.agence,
      });
    }

    setShowErrors({...showErrors, [name]: _value !== fired});
  };

  const noError = () => {
    let bNoError = true;
    Object.values(errors).forEach(element => {
      if (element !== '') {
        bNoError = false;
      }
    });
    return bNoError;
  };

  const handleSubmit = () => {
    setShowErrors(showErrorValuesSubmit);
    setErrors(Validate(values, listAgence));
    if (noError()) {
      setDto({error: false, data: values});
    } else {
      setDto({error: true, data: {}});
    }
  };

  useEffect(() => {
    setErrors(Validate(values, listAgence));
  }, [values]);

  useEffect(() => {
    if (!dto.error) {
      handleSave();
    }
  }, [dto]);

  return {handleChange, handleSubmit, values, errors, showErrors, dto};
};
